export default "__VITE_ASSET__CQ0s2KxV__"